import { CirclePlus } from 'lucide-react';
import { Button } from '@/components/ui';
import HeaderPageFilters from './HeaderPageFilters';
import HeaderPageSearch from './HeaderPageSearch';
import { cn } from '@/lib/utils';
import { TCreateParams } from '@/hooks/forms/useFormAccountingUser';

interface TProps {
    onCreate: (params?: TCreateParams) => void;
    isLoading?: boolean;
}

const HeaderPage = ({ onCreate, isLoading }: TProps) => {

    const handleOnClickBtn = () =>
        onCreate();

    return (
        <div className="flex flex-col space-y-4">
            {/* Header Top - Display add button on mobile only */}
            <div className='md:hidden'>
                <Button
                    onClick={handleOnClickBtn}
                    className='w-full h-10 bg-black text-white hover:bg-black/90 space-x-2 font-semibold shadow-xs'>
                    <CirclePlus size={18} />
                    <span>Ajouter un utilisateur</span>
                </Button>
            </div>

            <div className={cn(
                'flex flex-col space-y-3',
                'md:flex-row md:items-center md:justify-between md:gap-4 md:space-y-0',
            )}>
                {/* Desktop View: Left side contains Filters and Search */}
                <div className='flex flex-col space-y-3 md:flex-row md:items-center md:gap-4 md:flex-1 md:space-y-0'>
                    <div className='hidden md:block'>
                        <HeaderPageFilters isLoading={isLoading} />
                    </div>

                    <div className="w-full md:w-auto md:max-w-xs">
                        <HeaderPageSearch />
                    </div>
                </div>

                {/* Desktop View: Right side contains Add Button */}
                <div className='hidden md:block'>
                    <Button
                        variant={'secondary'}
                        onClick={handleOnClickBtn}
                        title='Ajouter un utilisateur comptable'
                        className='h-9 space-x-2 bg-black text-white hover:bg-black/80'>
                        <CirclePlus size={16} />
                        <span className='text-xs font-semibold'>
                            Ajouter
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    );

};

export default HeaderPage;
